<template>
  <div class="ICP">
    <b>上海市吴中路686号东航金融中心</b>
    <b>4008-889-889</b>
    <br/>
    <b>沪ICP备14006107号-1 </b>
    <b>沪公网安备 31011202001150号</b>
    <b>本站支持IPV6</b>
  </div>
</template>

<script>
  export default {
    name: 'ICP'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  .ICP
    background-color $color1
    color $font_color2
    font-size 9px
    text-align center
    height 50px
    padding-top 6px
    b
      font-weight normal
</style>



// WEBPACK FOOTER //
// ICP.vue?43068c7d